import { useDispatch } from 'react-redux'
import { MapLegendDrawer as Drawer } from 'ui-components'

import { useLegend, useLegendDrawerTitle } from '~map-preview/states/legend'
import {
  closeMapLegendDrawer,
  openMapLegend,
  useIsMapLegendDrawerOpen
} from '~map-preview/states/ui'

function MapLegendDrawer() {
  const dispatch = useDispatch()

  const open = useIsMapLegendDrawerOpen()
  const title = useLegendDrawerTitle()
  const legend = useLegend()

  const handleClose = () => {
    dispatch(closeMapLegendDrawer())
    dispatch(openMapLegend())
  }

  return (
    <Drawer
      open={open}
      title={title}
      legend={legend}
      onClose={handleClose}
    />
  )
}

export { MapLegendDrawer }
